<template>
  <div>
    <div class="title">
      {{ _[details.model] }} ID: {{ details.id }}
      <span @click="closeModal()"><font-awesome-icon :icon="['fas', 'times']" /></span>
    </div>
    <div class="content">
      <component :is="this.details.model.charAt(0).toUpperCase() + this.details.model.slice(1) + 'Details'" :id="details.id" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SessionDetails from '@/components/details/SessionDetails'
import PresentationDetails from '@/components/details/PresentationDetails'
import PersonDetails from '@/components/details/PersonDetails'
import RoomDetails from '@/components/details/RoomDetails'
import MeetingDetails from '@/components/details/MeetingDetails'
import MailingDetails from '@/components/details/MailingDetails'
export default {
  components: {
    SessionDetails,
    PresentationDetails,
    PersonDetails,
    RoomDetails,
    MeetingDetails,
    MailingDetails,
  },
  methods: {
    ...mapMutations(['closeModal']),
    handleKeyUp(event) {
      if (event.keyCode === 27) {
        this.coseModal();
      }
    }
  },
  computed: {
    ...mapGetters(['details']),
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.modal {
  > div {
    > div {
      display: grid;
      grid-template-rows: 40px 1fr;
      grid-template-columns: 1fr;
      height: 100%;
      > .title {
        grid-area: 1/1/2/2;
        background: $primary-color;
        color: #ffffff;
        padding: 12px;
        font-weight: bold;
        > span {
          float: right;
          margin-right: 4px;
          opacity: .4;
          &:hover {
            opacity: 1;
          }
        }
        .svg-inline--fa {
          cursor: pointer;
        }
      }
      > .content {
        grid-area: 2/1/3/2;
        background: #ffffff;
        overflow-y: scroll;
        position: relative;
        > div {
          position: relative;
          > div {
            position: relative;
          }
        }
      }

    }
  }
}

</style>